import { Phone, Clock, CalendarCheck, MapPin, Smartphone } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { PHONE_DISPLAY, PHONE_TEL, MOBILE_DISPLAY, MOBILE_TEL, HOURS, ADDRESS } from "../data/content";

const STEPS = [
  { icon: Phone, title: "Chiamaci", text: "Un numero, nessun modulo: parli direttamente con noi e ti consigliamo il trattamento più adatto." },
  { icon: CalendarCheck, title: "Scegliamo insieme data e orario", text: "Troviamo il momento migliore per te, anche il sabato mattina." },
  { icon: MapPin, title: "Ti aspettiamo in centro", text: "Arrivi, respiri e ti lasci prendere cura. Il resto lo facciamo noi." },
];

export const Booking = () => (
  <section id="prenota" className="relative overflow-hidden bg-sage-dark py-24 text-cream md:py-36 grain" data-testid="booking-section">
    <div className="pointer-events-none absolute -right-32 -top-32 h-[28rem] w-[28rem] rounded-full bg-sage/40 blur-3xl" />
    <div className="container-x relative grid gap-16 lg:grid-cols-12 lg:items-center">
      <div className="lg:col-span-6">
        <SectionHeading
          id="booking"
          light
          eyebrow="Prenotazione"
          title={<>Per prenotare basta <em className="font-normal italic text-gold-light">una telefonata</em>.</>}
          subtitle="Preferiamo il contatto diretto: così possiamo ascoltarti, consigliarti e trovare subito l'orario giusto. Chiamaci negli orari di apertura."
        />
        <Reveal delay={0.25} className="mt-10">
          <a
            href={PHONE_TEL}
            className="group inline-flex items-center gap-5 rounded-full bg-cream pl-3 pr-8 py-3 text-ink transition-[transform,box-shadow] duration-500 hover:-translate-y-1 hover:shadow-[0_30px_50px_-25px_rgba(250,248,245,0.5)]"
            data-testid="booking-call-btn"
          >
            <span className="relative flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-gold text-white">
              <span className="absolute inset-0 rounded-full bg-gold animate-pulseRing" />
              <Phone className="relative h-6 w-6" />
            </span>
            <span>
              <span className="block text-[11px] uppercase tracking-[0.25em] text-muted">Chiama ora</span>
              <span className="block font-serif text-3xl leading-tight md:text-4xl">{PHONE_DISPLAY}</span>
            </span>
          </a>
        </Reveal>
        <Reveal delay={0.3} className="mt-4">
          <a href={MOBILE_TEL} className="inline-flex items-center gap-3 rounded-full border border-cream/25 px-6 py-3 text-cream transition-colors hover:bg-cream/10" data-testid="booking-mobile-btn">
            <Smartphone className="h-4 w-4 text-gold-light" />
            <span className="text-[11px] uppercase tracking-[0.2em] text-cream/60">Cellulare</span>
            <span className="font-semibold">{MOBILE_DISPLAY}</span>
          </a>
        </Reveal>
        <Reveal delay={0.35} className="mt-8 flex items-start gap-3 text-sm text-cream/70">
          <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold-light" />
          <p>{ADDRESS}</p>
        </Reveal>
      </div>

      <div className="grid gap-5 lg:col-span-6">
        <div className="grid gap-4 sm:grid-cols-3">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={0.1 * i} className="h-full">
              <div className="flex h-full flex-col rounded-[1.4rem] border border-cream/10 bg-cream/5 p-6 backdrop-blur-sm" data-testid={`booking-step-${i}`}>
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gold/20 text-gold-light"><s.icon className="h-4 w-4" /></span>
                <h3 className="mt-5 font-serif text-xl leading-tight">{s.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-cream/60">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <div className="rounded-[1.6rem] bg-cream p-7 text-ink" data-testid="booking-hours-card">
            <div className="flex items-center gap-3">
              <Clock className="h-5 w-5 text-gold" />
              <span className="text-[11px] uppercase tracking-[0.25em] text-muted">Quando chiamarci</span>
            </div>
            <ul className="mt-4 grid gap-x-8 gap-y-2 sm:grid-cols-2">
              {HOURS.map((h) => (
                <li key={h.day} className={`flex justify-between border-b border-sage/10 py-2 text-sm ${h.closed ? "text-muted/60" : "text-ink"}`}>
                  <span>{h.day}</span><span className="font-medium tabular-nums">{h.hours}</span>
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
